var labels = {
  title: {
    es: 'Migraciones',
    en: 'Migrations'
  },
  email_migration: {
    es: 'Migración de Correos',
    en: 'Email Migration'
  },
  add_row: {
    es: 'Agregar Fila',
    en: 'Add Row'
  },
  load_csv: {
    es: 'Cargar CSV',
    en: 'Load CSV'
  },
  execute: {
    es: 'Ejecutar Migración',
    en: 'Execute Migration'
  },
  old_email: {
    es: 'Correo Antiguo',
    en: 'Old Email'
  },
  new_email: {
    es: 'Correo Nuevo',
    en: 'New Email'
  },
  old_email_placeholder: {
    es: 'user@old.pe',
    en: 'user@old.pe'
  },
  new_email_placeholder: {
    es: 'user@new.pe',
    en: 'user@new.pe'
  },
  valid: {
    es: 'Válido',
    en: 'Valid'
  },
  actions: {
    es: 'Acciones',
    en: 'Actions'
  },
  results: {
    es: 'Resultados',
    en: 'Results'
  },
  successful: {
    es: 'Exitosos',
    en: 'Successful'
  },
  failed: {
    es: 'Fallidos',
    en: 'Failed'
  },
  success: {
    es: 'Éxito',
    en: 'Success'
  },
  error: {
    es: 'Error',
    en: 'Error'
  },
  status: {
    es: 'Estado',
    en: 'Status'
  },
  message: {
    es: 'Mensaje',
    en: 'Message'
  },
  invalid_csv_format: {
    es: 'Formato de CSV inválido. Debe contener columnas "correo_antiguo" y "correo_nuevo"',
    en: 'Invalid CSV format. Must contain "correo_antiguo" and "correo_nuevo" columns'
  },
  csv_loaded: {
    es: 'Se cargaron {count} registros correctamente',
    en: 'Successfully loaded {count} records'
  },
  invalid_rows: {
    es: 'Hay filas con correos inválidos. Por favor corrija antes de continuar.',
    en: 'There are rows with invalid emails. Please fix them before continuing.'
  },
  no_valid_rows: {
    es: 'No hay filas válidas para migrar.',
    en: 'No valid rows to migrate.'
  },
  confirm_title: {
    es: 'Confirmar Migración',
    en: 'Confirm Migration'
  },
  confirm_text: {
    es: '¿Está seguro de que desea ejecutar la migración de correos?',
    en: 'Are you sure you want to execute the email migration?'
  },
  migration_complete: {
    es: 'Migración completada exitosamente',
    en: 'Migration completed successfully'
  },
  migration_partial: {
    es: 'Migración completada con algunas fallas',
    en: 'Migration completed with some failures'
  },
  migration_error: {
    es: 'Error al ejecutar la migración',
    en: 'Error executing migration'
  }
};
export default labels;